function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1893.59,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M20828 15779c-1,2739 -2221,4958 -4960,4958 -2739,0 -4958,-2221 -4958,-4959 0,-2739 2220,-4959 4959,-4959 1316,0 2577,522 3508,1453 930,930 1452,2192 1452,3508zm-5051 -8925c-5201,-90 -10581,3635 -13963,7451 -735,836 -735,2107 0,2944 3309,3735 8673,7546 13963,7455 5291,91 10656,-3720 13967,-7455 735,-836 735,-2107 0,-2944 -3386,-3815 -8766,-7540 -13967,-7451z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 31558 31558",
    className: "icon",
    style: {
      "height": "1em",
      "width": "1em"
    }
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/eye.70812fa8.svg";
export { SvgComponent as ReactComponent };